import { TSelectOption } from "@hsr/types";

// Please adjust i18n locales accordingly > orderReturn.json
export const ORDER_RETURN_REASON_OPTIONS: TSelectOption[] = [
  {
    // use value as i18n translation key
    value: "reason1",
    // label will be translated
    label: "Wrong product"
  },
  {
    value: "reason2",
    label: "Damaged product"
  },
  {
    value: "reason3",
    label: "Quality defect"
  },
  {
    value: "reason4",
    label: "Incomplete delivery"
  },
  {
    value: "reason5",
    label: "Overdelivery"
  },
  {
    value: "reason6",
    label: "Mistakenly ordered"
  }
];
